import { render, staticRenderFns } from "./Unsubscribed.vue?vue&type=template&id=cefe9ec2&"
import script from "./Unsubscribed.vue?vue&type=script&lang=js&"
export * from "./Unsubscribed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports